// eslint-disable-next-line import/extensions
import {
  AnalyticsService as KMPAnalyticsService,
  EventParams,
  EventService,
  getBirthYearOptionsAsArray,
  IdentitySDK as KMPIdentitySDK,
  IdmServerErrorTypeNames as KMPIdmServerErrorTypeNames,
  IdmService as KMPIdmService,
  LogHelpers as KMPLogHelpers,
  maskEmailAddress,
  PageName,
  validateEmailWithServerRegex,
} from 'identity-sdk-core'

export {
  getTextAndCursorPositionOnTelephoneEnter,
  getTextAndCursorPositionOnTelephoneDelete,
  generateCodeChallengeAndRedirect,

  // Analytics
  EventParams,
  PageName,
  PageType,
  SignInType,
  SignOutType,
  OpenType,
  ClickLocation,
  ConditionType,
  ErrorSystem as AnalyticsErrorSystem,
  ErrorType as AnalyticsErrorType,
  AuthenticationFlow,
  AnalyticsEventMetadata,

  // State Machine
  AuthenticationNavigationStateMachine,

  // Zero Bounce
  EmailValidationStatus,

  // MParticle
  SignOutEventParams,

  // Passkey
  PasskeyAuthMode,

  // Models
  FirstPartyDataInputField,
  Profile,
  Gender,

  // Helpers
  mapOf,
  meetsRequirements as isProfileValid,
  shippingAddressComplete as isShippingAddressValid,
} from 'identity-sdk-core'

export const IdentitySDK = KMPIdentitySDK.getInstance()
export const IdmService = KMPIdmService.getInstance()
export const AnalyticsEventDispatcher = EventService.getInstance()
export const AnalyticsService = KMPAnalyticsService.getInstance()
export const LogHelpers = KMPLogHelpers.getInstance()
export const IdmServerErrorTypeNames = KMPIdmServerErrorTypeNames.getInstance()

export function configureIdentitySdk(
  config,
  language,
  debug,
  eventLogger,
  remoteConfigProvider,
  covaticEventLogger,
) {
  IdentitySDK.init(
    config.brand.source,
    config.brand.product,
    config.brand.parameter,
    config.crossDomain?.clientId,
    language,
    eventLogger,
    covaticEventLogger,
    config.sessionTimeout,
    debug,
    remoteConfigProvider,
    config.key,
  )
}

export function setSdkVersion(version) {
  IdentitySDK.setSdkVersion(version)
}

export function getSessionToken() {
  return IdentitySDK.getSessionToken()
}

export function getSavedProfile() {
  return IdentitySDK.getSavedProfile()
}

export function maskEmail(email) {
  return maskEmailAddress(email)
}

export function validateEmailLocally(email) {
  return validateEmailWithServerRegex(email)
}

export function getBirthYearOptions(birthDay, birthMonth, currentDay, currentMonth, currentYear) {
  return getBirthYearOptionsAsArray(birthDay, birthMonth, currentDay, currentMonth, currentYear)
}

export function getHealth(environment) {
  return IdmService.getHealth(environment)
}

export function createEventParams(
  pageName,
  openType,
  registrationReferrer = null,
  referringPage = null,
) {
  return new EventParams(
    pageName.pageEventName,
    registrationReferrer ?? 'NBC Login',
    referringPage ?? 'None',
    pageName.pageType.pageTypeEventName,
    openType.openTypeEventName,
  )
}

export function getCompleteProfilePageName(newAccount) {
  return newAccount ? PageName.COMPLETE_PROFILE_CREATE : PageName.COMPLETE_PROFILE_LOGIN
}
